// import { AvProxyApi } from '@availity/api-axios';
import axios from 'axios';
// import commonStore from '../../stores/commonStore';
// import * as appBrand from '../../config/app-brand-config.json';

// const transactionProxy = new AvProxyApi({ tenant: 'anthem', name: 'v1/providerapp/logging/transactions' });
// const disclaimerProxy = new AvProxyApi({ tenant: 'anthem', name: 'v1/providerapp/utilities/disclaimer' });

// export const transactions = params => transactionProxy.post(params);

export const transactions = params => {
  axios.post('/v1/providerapp/logging/transactions', params)
  .then(response => {return response})
  .catch(error => error);
}

// export const getTermsOfUse = async() => {
//   const { userAndBrand } = commonStore;
//   const params = {
//     brand: userAndBrand.brand.code,
//     state: userAndBrand.brand.state,
//     application: appBrand.termsOfUse.applicationId,
//     parameters: []
//   };
//   const response = await axios.post('/')
//   disclaimerProxy.post(params);
//   return response;
// };

// export const getDisclaimer = async() => {
//   const { userAndBrand } = commonStore;
//   const params = {
//     brand: userAndBrand.brand.code,
//     state: userAndBrand.brand.state,
//     application: appBrand.disclaimer.applicationId,
//     parameters: []
//   };
//   const response = await disclaimerProxy.post(params);
//   return response;
// };

export default transactions;
